import React from 'react';
import { featuredDresses } from '../data/mockData';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const FeaturedDresses = ({ onDressInquiry }) => {
  return (
    <section id="featured-dresses" className="py-20 bg-neutral-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">Nuestros favoritos</h2>
          <p className="text-neutral-600 font-light">Valores de referencia sujetos a disponibilidad, fecha y sede</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {featuredDresses.map((dress) => (
            <Card 
              key={dress.id} 
              className="group overflow-hidden border-0 shadow-sm hover:shadow-xl transition-all duration-500 bg-white"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-neutral-100">
                <img
                  src={dress.image}
                  alt={dress.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-serif text-neutral-900 mb-4">{dress.name}</h3>
                <Button
                  onClick={() => onDressInquiry(dress.name)}
                  variant="outline"
                  className="w-full border-neutral-900 text-neutral-900 hover:bg-neutral-900 hover:text-white transition-all duration-300 rounded-sm"
                >
                  Consultar disponibilidad
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedDresses;
